import { render } from "./Footer1.vue?vue&type=template&id=f598df28&ts=true"
import script from "./Footer1.vue?vue&type=script&lang=ts"
export * from "./Footer1.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__